export const ALL_COUNTIES = 'all';
export type AllCounties = typeof ALL_COUNTIES;
export type SelectedCounties = AllCounties | number[];
